import { ContactRequest } from './../model/contact/contact-request';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from "rxjs/Observable";

@Injectable()
export class ContactRequestService {

  constructor(
    private http: Http
  ) { }

  public doContactRequest(request: ContactRequest): Observable<Response> {
    return this.http.post("/backend/contact.php", request);
  }

}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/services/contact-request.service.ts